import type { ChildrenProps } from 'types';
import AxiosSetting from './AxiosSetting';
import ReactQuerySetting from './ReactQuerySetting';
import RouterSetting from './RouterSetting';
import SentrySetting from './SentrySetting';

const AppSetting = ({ children }: ChildrenProps) => (
  <SentrySetting>
    <ReactQuerySetting>
      <AxiosSetting>
        <RouterSetting>{children}</RouterSetting>
      </AxiosSetting>
    </ReactQuerySetting>
  </SentrySetting>
);

export default AppSetting;
